module.exports = __webpack_public_path__ + "assets/144d59bd5d32d2b38b799b21884cc231.professional_choice.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/professional_choice.png
 ** module id = 841
 ** module chunks = 1
 **/